import styled from 'styled-components';

const Wrapper = styled.aside`
  display: none;
  @media (min-width: 992px) {
    display: block;
    box-shadow: -1px 0px 0px 0px rgba(0, 0, 0, 0.1); /* Flipped shadow for RTL */

    .sidebar-container {
      background: var(--background-secondary-color);
      min-height: 100vh;
      height: 100%;
      width: 250px;
      position: fixed; /* Fixed position */
      right: 0; /* Align to the right */
      transform: translateX(100%); /* Initially move offscreen to the right */
      transition: transform 0.3s ease-in-out; /* Transition for moving */
      z-index: 1;
    }

    .show-sidebar {
      transform: translateX(0); /* Bring sidebar into view */
    }

    .content {
      position: sticky;
      top: 0;
      transition: margin-right 0.3s ease-in-out; /* Transition for moving content */
    }

    .show-sidebar + .content {
      margin-right: 250px;
      /* background : red; */
    }

    header {
      height: 6rem;
      display: flex;
      align-items: center;
      padding-right: 2.5rem; /* Flipped padding for RTL */
    }

    .nav-links {
      padding-top: 2rem;
      display: flex;
      flex-direction: column;
    }
    .nav-link {
      display: flex;
      align-items: center;
      color: var(--text-secondary-color);
      padding: 1rem 0;
      padding-right: 2.5rem; /* Flipped padding for RTL */
      text-transform: capitalize;
      transition: padding-right 0.3s ease-in-out;
    }

    .nav-link:hover {
      padding-right: 3rem; /* Flipped padding on hover for RTL */
      color: var(--primary-500);
      transition: var(--transition);
    }

    .icon {
      font-size: 1.5rem;
      margin-left: 1rem; /* Flipped margin for RTL */
      display: grid;
      place-items: center;
    }

    .active {
      color: var(--primary-500);
    }

    .pending {
      background: var(--background-color);
    }
      .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border-color: transparent;
    font-size: 2rem;
    color: var(--red-dark);
    cursor: pointer;
  }
  }
`;

export default Wrapper;
